import MuiSelect from '@mui/material/Select';
import styledMmmField from './styledMmmField';

export const Select = styledMmmField(MuiSelect);
